import type { Team } from "@/types/team";
import type { User, UserRole } from "@/types/user";

export const USER_KEY = "user";
export const TEAM_KEY = "team";
const ls = window.localStorage



if(ls === undefined){
  throw "LocalStorage not available!"
}
/**
 * @description get cached User form localStorage
 */
export const getStoredUser = (): User | undefined => {
  const cached = ls.getItem(USER_KEY)
  if (!cached) {
    return undefined
  }

  const user = JSON.parse(cached) as User & { roles?: UserRole[] }
  if (user.is_admin === undefined) {
    user.is_admin = Boolean(user.roles?.includes("OA"))
  }
  delete user.roles
  return user;
};

/**
 * @description get cached Team from localStorage
 */
export const getStoredTeam = (): Team | undefined => {
  const cached = ls.getItem(TEAM_KEY)
  return cached ? JSON.parse(cached) as Team : undefined;
};

/**
 * @description save User into localStorage
 */
export const storeUser = (user: User): void => {
  ls.setItem(USER_KEY, JSON.stringify(user));
};

/**
 * @description save Team into localStorage
 */
export const storeTeam = (team: Team): void => {
  ls.setItem(TEAM_KEY, JSON.stringify(team));
};

/**
 * @description remove User and Team from localStorage
 */
export const deleteUser = (): void => {
  ls.removeItem(USER_KEY);
  ls.removeItem(TEAM_KEY);
};


export default { getStoredUser, getStoredTeam, storeUser, storeTeam, deleteUser };
